export default __webpack_public_path__ + "images/4e4582f7f8d9c869108f2838392cf76e.png";